// Счётчики для бейджей (ux/02 §1): готовые к сбору награды на вкладке «Задания», письма с вложениями — конверт на главном.
import { signal } from '@preact/signals';

export const questsClaimable = signal(0);
export const mailUnclaimed = signal(0);

/** 04:00 МСК — граница игрового дня (ux/09 §1.1): ближайшая после now (01:00 UTC). */
export function nextDayStart(now: number): number {
  const d = new Date(now);
  const t = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 1, 0, 0);
  return t > now ? t : t + 86_400_000;
}
